import { ConversationClassification, MessageIntent } from "../models/conversation.models";

export function classificationTag(classification: ConversationClassification): string {
    switch (classification) {
        case ConversationClassification.ORDER:
            return 'class-order';
        case ConversationClassification.RFQ:
            return 'class-rfq';
        case ConversationClassification.SUPPORT:
            return 'class-support';
        case ConversationClassification.INQUIRY:
            return 'class-inquiry';
        case ConversationClassification.ADMIN:
            return 'class-admin';
        case ConversationClassification.SPAM:
            return 'class-spam';
        case ConversationClassification.OTHER:
            return 'class-other';
        case ConversationClassification.UNDEFINED:
            return 'class-undefined';
        default:
            return 'class-undefined';
    }
}

/**
 * Sinks "undefined" to the end of a category rollup so a thread that also carries
 * a real category never leads with it. Order is otherwise preserved (the backend
 * returns most-recent-first).
 */
export function orderCategories(categories: ConversationClassification[]): ConversationClassification[] {
    const isUndefined = (c: ConversationClassification) => c === ConversationClassification.UNDEFINED;
    return [...categories.filter((c) => !isUndefined(c)), ...categories.filter(isUndefined)];
}

/** Translation key for a category, falling back to "undefined" when absent. */
export function classificationLabelKey(classification?: string | null): string {
    const known = Object.values(ConversationClassification) as string[];
    const value = classification && known.includes(classification) ? classification : ConversationClassification.UNDEFINED;
    return `smart_inbox.inbox_view.detail.classification_${value}`;
}

/**
 * Translation key for an intent. The classifier owns an open list, so an intent
 * we have no translation for falls back to `humanizeIntent()` at render time —
 * see `intentLabel()`.
 */
export function intentLabelKey(intent: MessageIntent): string {
    return `smart_inbox.inbox_view.detail.intent_${intent.toLowerCase()}`;
}

/** `ORDER_PLACING` → `Order placing`. Fallback for intents we don't translate. */
export function humanizeIntent(intent: MessageIntent): string {
    const words = intent.replace(/_/g, ' ').trim().toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
}
